const isString = (str) => (typeof str === 'string' || str instanceof String);

const whenNot = (pred) => (parser) => (input) =>
        (pred(input) ? input : parser(input));

const whenNotNull = (parser) => (input) =>
        ((input === undefined || input === null) ? undefined : parser(input));

const whenNotInteger = whenNot(Number.isInteger);
const whenNotBoolean = whenNot(input => typeof input === 'boolean');
const whenNotNumber = whenNot(input => typeof input === 'number');
const whenNotString = whenNot(isString);

const coerceOrParse = (coerce, parse) => (input) =>
        (isString(input) ? parse(input) : coerce(input));

export const toBoolean = whenNotNull(whenNotBoolean(coerceOrParse(
  (input) => !!input,
  (input) => {
    if (input.trim() === 'true') {
      return true;
    }
    if (input.trim() === 'false') {
      // this case isn't needed, the parseInt will catch it, but explicit is better than implicit
      return false;
    }
    return parseInt(input, 10) > 0;
  }
)));

export const toLong = whenNotNull(whenNotInteger(coerceOrParse(
  (input) => parseInt(Number(input), 10),
  (input) => parseInt(input, 10)
)));

export const toDouble = whenNotNull(whenNotNumber(coerceOrParse(
  (input) => Number(input),
  (input) => parseFloat(input)
)));

export const toString = whenNotNull(whenNotString((input) => input.toString()));

export const toStringArray = whenNotNull(
  (input) => ((Array.isArray(input)) ?
             input.map(toString) :
             input.split(',').map(item => item.trim()))
);

export const toNull = whenNotNull(() => null);



// WEBPACK FOOTER //
// ./lib-bb-widget/scripts/parse-preference.js